import { Box, useTheme } from "@mui/material";
import React, { FC, ReactNode } from "react";
import MobileStepper from "@mui/material/MobileStepper";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { paletteColors } from "../../styles/muiTheme";

interface ICarouselAvailableTimeSlotsProps {
  currentIndex: number;
  handleNext: () => void;
  handleBack: () => void;
  optionsLength: number;
  children: ReactNode;
  itemsPerPage: number;
  position?: "sides" | "below";
}

export const MobileStepperStyles = {
  "& .MuiMobileStepper-dotActive": {
    backgroundColor: paletteColors.warning.main,
  },
  "& .MuiMobileStepper-dot": {
    height: "5px",
    width: "5px",
  },
};

const GenericCarousel: FC<ICarouselAvailableTimeSlotsProps> = ({
  currentIndex,
  handleNext,
  handleBack,
  optionsLength,
  children,
  itemsPerPage,
  position="sides",
}) => {
  const theme = useTheme();

  return (
    <div className="w-full flex flex-col">
      {position === "sides" && <Box className="flex">
        <button onClick={handleBack}>
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight className="rounded-full bg-taupe-1 text-light-black" />
          ) : (
            <KeyboardArrowLeft className="rounded-full bg-taupe-1 text-light-black" />
          )}
        </button>

        <Box className="!w-full">
          {children}
        </Box>
        <button onClick={handleNext}>
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft className="rounded-full bg-taupe-1 text-light-black" />
          ) : (
            <KeyboardArrowRight className="rounded-full bg-taupe-1 text-light-black" />
          )}
        </button>
      </Box>}
      {optionsLength > 0 && position==="sides" && (
        <MobileStepper
          variant="dots"
          steps={Math.ceil(optionsLength / itemsPerPage)}
          position="static"
          activeStep={currentIndex}
          className="!w-full !bg-transparent flex flex-col !justify-center"
          nextButton={undefined}
          backButton={undefined}
          sx={MobileStepperStyles}
        />
      )}
      {position==="below" &&
      <Box className="flex flex-col">
        <Box className="!w-full">
          {children}
        </Box>
        <div className="flex justify-between mt-1">
          <button onClick={handleBack}>
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight className="rounded-full bg-taupe-1 text-light-black" />
            ) : (
              <KeyboardArrowLeft className="rounded-full bg-taupe-1 text-light-black" />
            )}
          </button>
          {optionsLength > 0 && (
            <MobileStepper
              variant="dots"
              steps={Math.ceil(optionsLength / itemsPerPage)}
              position="static"
              activeStep={currentIndex}
              className="!w-full !bg-transparent flex flex-col !justify-center"
              nextButton={undefined}
              backButton={undefined}
              sx={MobileStepperStyles}
            />
          )}

          <button onClick={handleNext}>
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft className="rounded-full bg-taupe-1 text-light-black" />
            ) : (
              <KeyboardArrowRight className="rounded-full bg-taupe-1 text-light-black" />
            )}
          </button>
        </div>
      </Box>
      }
    </div>
  );
};

export default GenericCarousel;
